var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckFillBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z",
    fill: "#556BB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2341 17.6981C51.5354 16.5933 49.1487 16.9347 47.9057 18.446L28.6241 41.9825L22.2064 34.7467C20.8986 33.2773 18.5014 33.0272 16.8517 34.1864C15.197 35.3459 14.9185 37.4851 16.2213 38.9495L28.8663 53.2155L54.068 22.4404C55.3109 20.924 54.9379 18.8029 53.2341 17.6981Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFillBlue);
export default __webpack_public_path__ + "static/media/check-fill-blue.31339b7090cc8eb5b85f139b44569d48.svg";
export { ForwardRef as ReactComponent };